module.exports = __webpack_public_path__ + "8f4907852ad6cfa5939029bbb2311082.jpg";